import useSocialAccounts from './useSocialAccounts'

export interface UseHasSocialAccountsResult {
  hasSocialAccounts?: boolean
  isLoading: boolean
}

export const useHasSocialAccounts = (): UseHasSocialAccountsResult => {
  const { socialAccounts, isLoading } = useSocialAccounts()

  if (isLoading) return { isLoading }

  const hasSocialAccounts = Array.isArray(socialAccounts) ? socialAccounts.length !== 0 : undefined

  return { hasSocialAccounts, isLoading }
}
